export const COMPLAINTS_PAGE_URL = '/complaint';
export const INDIVIDUAL_COMPLAINT_URL = '/individual-complaint';
export const COMPANY_COMPLAINT_URL = '/company-complaint';
export const HOME_URL = '/';
export const VIEW_COMPLAINTS_URL = '/view-complaints';
export const FAQs = '/faqs';

export const ACMA_ABOUT_US = 'https://medicalaffairsspecialist.org/about';
export const ACMA_CONTACT_US = 'https://medicalaffairsspecialist.org/about/contact-us';
